import React from "react";
import DateHelper from "../../DateHelper/DateHelper";
import {  isSameDay, isAfter } from 'date-fns';

class ReservationSegmentStatusDataType extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
    var daily_rental = this.props.row.daily_rental;
		var check_in_date = DateHelper.parseDateFromBackend(this.props.row.check_in_date);
		var check_out_date = DateHelper.parseDateFromBackend(this.props.row.check_out_date);
		var currentDate = DateHelper.parseDateFromBackend(this.props.row.currentDate) || DateHelper.today();
		var todaysDate = DateHelper.today()
		var check_in_today =  isSameDay(check_in_date, todaysDate)
		var check_out_today =  isSameDay(check_out_date, todaysDate)
		var before_check_in = isAfter(check_in_date, todaysDate)
		var before_check_out = isAfter(check_out_date, currentDate)
		var passed_check_in = isAfter(todaysDate, check_in_date)
		var passed_check_out = isAfter(todaysDate, check_out_date)

    if(this.props.row.status == 'active') {
			if (check_in_today && this.props.row.dashboard) {

        return (
          <div>
            <button type="button" className={"btn btn-success btn-sm modal-iframe"} data-fullscreen="true" data-nested="true" href={`/admin/reservation_segments/${this.props.row.id}/check_in`} >
              {I18n.t('check_in')}
            </button>
          </div>
        );
      } else if (passed_check_in && !passed_check_out && this.props.row.dashboard) {
        return (
					<div>
            <div>{I18n.t('missed_check_in')}</div>
						<button type="button" className={"btn btn-success btn-sm modal-iframe"} data-fullscreen="true" data-nested="true" href={`/admin/reservation_segments/${this.props.row.id}/check_in`} >
							{I18n.t('check_in')}
						</button>
					</div>
				);
      } else if (passed_check_out && this.props.row.dashboard) {
        return (
          <div>
            <div>{I18n.t('missed_check_in')}</div>
            <button type="button" className={"btn btn-danger btn-sm modal-iframe"} data-fullscreen="true" data-nested="true" href={`/admin/reservation_segments/${this.props.row.id}/check_out`} >
              {I18n.t('check_out')}
            </button>
          </div>
        );
      } else if (before_check_in && this.props.row.dashboard) {
				return (
					<div>{I18n.t('active') }</div>
				);
			}
    } else if (this.props.row.status == 'checked_in') {
      if (check_out_today && this.props.row.dashboard || daily_rental == true ) {
        return (
					<div>
						<button type="button" className={"btn btn-danger btn-sm modal-iframe"} data-fullscreen="true" data-nested="true" href={`/admin/reservation_segments/${this.props.row.id}/check_out`} >
							{I18n.t('check_out')}
						</button>
					</div>
				);
      } else if (passed_check_out && this.props.row.dashboard){
        return (
          <div>
            <div>{I18n.t('missed_check_out')}</div>
            <button type="button" className={"btn btn-danger btn-sm modal-iframe"} data-fullscreen="true" data-nested="true" href={`/admin/reservation_segments/${this.props.row.id}/check_out`} >
              {I18n.t('check_out')}
            </button>
          </div>
        );
      } else if(this.props.row.dashboard) {
        return (
					<div>{I18n.t('checked_in')}</div>
			  );
      };
    } else if (this.props.row.status == 'checked_out') {

	
        return (
          <div >{I18n.t('checked_out')}</div>
        );
	
    } else if (this.props.row.status == 'canceled') {
			// if (this.props.row.dashboard) {
          return (
            <div >{I18n.t('canceled')}</div>
          );
      // };
    } else if (this.props.row.status == 'no_show') {
      if (currentDate > check_out_date && this.props.row.dashboard) {
          return (
            <div>{I18n.t('no_show')}</div>
          );   
      };
    }

    ///////// Final catch to ensure something is pringed on screen with no breaking errors ////////////
    if (before_check_out && this.props.row.dashboard) {
        if (this.props.row.is_balanced) {
          return (
            <div style={{ color: 'red' }}>{I18n.t(this.props.row.status) + ' - ' + I18n.t('open_folios')}</div>
            );
          } else {
            return(
              <div style={{ color: 'red' }}>{I18n.t(this.props.row.status) + ' - ' + I18n.t('folios_out_of_balance')}</div>
            );
          };
      } else {
        return (
          <div>{this.props.row.status ? I18n.t(this.props.row.status) : ""}</div>
			  );
      };

	};
 
};

export default ReservationSegmentStatusDataType
